import "./App.css";
import Swap from "./Swap";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
import { bnbChainId, chain, rpcUrl } from "./utils/constants";
// 1. Get projectId at https://cloud.walletconnect.com
const projectId = "61d2c1fda6f35b603e3367b36447aa0a";

// 3. Create modal
const metadata = {
  name: "Token",
  description: "Token ICO",
  url: "https://mywebsite.com", // origin must match your domain & subdomain
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

createWeb3Modal({
  ethersConfig: defaultConfig({ metadata }),
  chains: [chain],
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
  themeVariables: {
    "--w3m-accent": "#472919",
    "--w3m-color-mix": "#472919",
  },
  themeMode: "light",
});
function App() {
  return (
    <div className="App">
      <Swap />
    </div>
  );
}

export default App;
